// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mdSH","title":"styles_title__UoSwq"};